import type { BusinessColor } from 'app-components/utils/theme';
import { businessColorReadable } from 'app-components/utils/theme';

export const getColorDisplayName = (color: BusinessColor): string => {
  const readable = businessColorReadable[color] ?? color;
  return readable.replace(/([A-Z])/g, ' $1').replace(/^[a-z]/, (c) => c.toUpperCase());
};

export const getAddBusinessColors = (
  availableColors: ReadonlyArray<BusinessColor>,
  selectedColor: BusinessColor | '' | null | undefined,
): ReadonlyArray<BusinessColor> => {
  const colors = availableColors as ReadonlyArray<BusinessColor>;

  if (selectedColor && !colors.includes(selectedColor)) {
    return colors.concat(selectedColor);
  }

  return colors;
};
